import { AbsoluteCenter, Box, Button, Heading, Spinner, Stack, Text, Flex, Link, Icon } from "@chakra-ui/react";

import { VITE_CONSENT_LIMIT_OFFER_URL } from "../../ENV.ts";
import { B2pLogoIcon } from "../../components/icons";
import { PageLoader } from "../../components/shared/PageLoader";
import { SMSResendTimer } from "../../components/features/LoginPage";
import { useSMSFormState } from "../../components/features/LoginPage/SMSForm/hooks";
import { B2pSMSForm } from "../../components/features/LoginPage/B2pOtpPage/B2pSMSForm";
import { useB2pCardStatusPolling } from "../../components/features/LoginPage/B2pOtpPage/hooks";
import { useLoginFormStore } from "../../store/loginFormStore";
import { ESMSFormState } from "../../store/slices/smsFormSliceCreator.ts";

export function B2pOtpPage() {
  const smsForm = useSMSFormState();
  const { isPolling } = useB2pCardStatusPolling();

  const handleSubmit = (): void => {
    if (smsForm.formState === ESMSFormState.initial) {
      smsForm.setFormState(ESMSFormState.validating);
    }
  };

  // Show PageLoader while polling status after OTP confirmation
  if (isPolling) {
    return <PageLoader />;
  }

  return (
    <Box position="relative" h="calc(100vh - 84px * 2)">
      <AbsoluteCenter axis="both">
        <Stack spacing={6} minW="300px">
          <Stack spacing={2}>
            <Flex justifyContent="center" alignItems="center">
              <Icon as={B2pLogoIcon} w="50px" h="31px" />
            </Flex>
            <Heading textAlign="center">Введите код из SMS</Heading>
            <Text size="sm" align="center">
              Best2Pay на ваш мобильный телефон направил код подтверждения
            </Text>
          </Stack>
          <B2pSMSForm />
          <Button colorScheme="brand" onClick={handleSubmit}>
            {smsForm.formState === ESMSFormState.initial
              ? "Продолжить"
              : <Spinner variant="white" />}
          </Button>
          <SMSResendTimer />
          <Text fontSize="xs" align="center">
            Нажимая кнопку  «Продолжить» вы соглашаетесь
            {" "}
            <br />
            с
            {" "}
            <Link href={VITE_CONSENT_LIMIT_OFFER_URL} textDecoration="underline">Офертой на открытие карты</Link>
          </Text>
        </Stack>
      </AbsoluteCenter>
    </Box>
  );
}

B2pOtpPage.loader = () => {
  const formState = useLoginFormStore.getState();
  formState.clearSMSForm();
  return null;
};
